module.exports = __webpack_public_path__ + "img/ic_ship.2cf20a1a.svg";